import styled from '@emotion/styled';

import { getColor } from '../../common/UICommon';

export const LetsHealTogetherHighlightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

export const LetsHealTogetherHighlightIcon = styled.img`
  max-height: 32px;
  max-width: 32px;
`;

export const LetsHealTogetherHighlightText = styled.div`
  color: ${getColor('WHITE')};
  font-family: Poppins;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  display: flex;
  align-items: center;
`;
